export default "__VITE_ASSET__18d9efbb__"